import React from "react";

import { Typography } from "@mui/material";

import Input, { InputProps } from "../Input";
import useStyles from "./styles";
import { colors } from "@zapalacorp/tokens";

const HorizontalInput = (props: InputProps) => {
  const { label, error, errorResponse, disabled, ...rest } = props;

  const classes = useStyles({
    bordercolor:
      error || (errorResponse && errorResponse?.field === rest.name)
        ? "#D92D20"
        : colors.brandBlue500,
    disabled,
  });

  return (
    <div className={classes.borderDiv}>
      <Typography
        color="#465869"
        fontFamily="Manrope"
        fontWeight={500}
        fontSize="12px"
        lineHeight="24px"
      >
        {label}
      </Typography>
      <Input formControlClassName={classes.input} disabled={disabled} {...rest} />
    </div>
  );
};

export default HorizontalInput;
